import App from 'app/app.js';
import { EventType } from '@app/interface/subject/subject.interface';

function LtSchoolSearchCtrl(
  $scope,
  $timeout,
  $filter,
  $location,
  RouterService,
  StatesService,
  TranslateProviderService,
  ErrorLogService,
  SubjectStore,
  MessageStore,
  UserProfileStore,
  BlockService,
  JobStore,
  AnalyticsService,
  ConfirmSchoolService,
  ShoppingCartStore,
  $injector,
  $window,
  AddNewStudentFormSubmissionService
) {
  var MAX_VALID_HOST_NAME_LENGTH = 90;

  const US_ZIP_CODE_LENGTH = 5;
  const CA_ZIP_CODE_LENGTH = 6;
  const CA_ZIP_TOTAL_LENGTH = 7;
  const SPACE_INDEX = 3;

  this.lastSearch = {};
  this.lastResults = [];
  this.accounts = [];
  this.isFindMyPictureDay = $scope.isFindMyPictureDay || false;
  this.fromBannerPage = $scope.fromBannerPage;
  this.selectedAccount = $scope.selectedAccount;
  this.studentIdSelected = false;
  this.fromConfirmExistingStudentPopup = $scope.fromConfirmExistingStudentPopup;
  this.isLoading = false;
  this.pictureDateInfo = [];
  this.allSubjects = [];
  this.retakeDateInfo = [];
  this.isErrorShowable = false;
  this.activeDayId = null;
  this.isFindSchool = $location.path() === RouterService.paths.FIND_SCHOOL;
  this.isLoggedIn = UserProfileStore.isLoggedIn();
  this.zipCodeError = false;
  this.validatingCode = false;

  this.init = function () {
    this.isCanadian = TranslateProviderService.isCanadianDomain();
    this.stateProvinces = this.isCanadian ? StatesService.getCanadianProvinces() : StatesService.getAmericanStates();

    let unwatchIsFindMyPictureDay = $scope.$watch(
      'isFindMyPictureDay',
      function (isFindMyPictureDay) {
        this.isFindMyPictureDay = isFindMyPictureDay;
      }.bind(this)
    );
    this.allSubjects = SubjectStore.getSortedVerifiedAndJobSubjects();
    this.selectedAccount = SubjectStore.getSelectedAccount();
    if (this.selectedAccount && this.selectedAccount.isFindMyPictureDay) {
      this.schoolZipCode = this.selectedAccount.zipcode;
      this.schoolState = this.selectedAccount.state;
      this.schoolName = this.selectedAccount.accountAlias;
      this.studentIdSelected = this.selectedAccount.studentIdSelected;
      this.lastSearch.schoolZipCode = this.schoolZipCode;
      this.lastSearch.schoolState = this.schoolState;
      this.pictureDateInfo = SubjectStore.getSelectedAccount().pictureDateInfo;
      this.retakeDateInfo = SubjectStore.getSelectedAccount().retakeDateInfo;
    } else {
      this.schoolZipCode = null;
      this.schoolState = null;
      this.schoolName = null;
      this.selectedAccount = null;
      this.studentIdSelected = false;
      this.lastSearch.schoolZipCode = this.schoolZipCode;
      this.lastSearch.schoolState = this.schoolState;
    }

    var formId = this.fromBannerPage
      ? AnalyticsService.ADOBE_FORM_IDS.ADD_NEW_STUDENT_ID
      : AnalyticsService.ADOBE_FORM_IDS.GUEST_FIND_MY_PICTURE_DAY;
    AnalyticsService.addAdobeFormLoadEvent(formId);

    $scope.$on('$destroy', function () {
      unwatchIsFindMyPictureDay();
    });
  };

  this.getAccountApi = () => $injector.get('AccountApi');

  // check if the last call to server would have gotten all the results
  this.needsOnlyFiltering = function () {
    var length = !!this.lastSearch.schoolName && this.lastSearch.schoolName.length;
    if (length && this.schoolName) {
      return this.schoolName.slice(0, length).toLowerCase() === this.lastSearch.schoolName.toLowerCase();
    }
    return false;
  };

  this.searchAccount = function (lifetouchId) {
    this.pictureDateInfo = [];
    this.isLoading = true;
    this.getAccountApi()
      .getAccount(lifetouchId)
      .subscribe({
        next: (response) => {
          $scope.$evalAsync(() => {
            this.selectedAccount.masterEvents = response.masterEvents;
            this.processSchoolEventDate();
            this.isLoading = false;
          });
        },
        error: (err) => {
          $scope.$evalAsync(() => {
            if (err.message === 'LMI_CLAIM_NOT_ALLOWED') {
              MessageStore.createSystem(err.message);
            } else {
              MessageStore.createSystem('COMMON_TEXT_ERROR');
            }
            ErrorLogService(err);
            this.isLoading = false;
            MessageStore.clear();
          });
        }
      });
  };

  this.getTitle = function () {
    var fmpdPageTitle = !!this.isFindMyPictureDay && !this.isFindSchool && 'FIND_MY_PICTURE_DAY_SCHOOL_SEARCH_TITLE';
    var landingPagTitle = !this.isFindMyPictureDay && !this.isFindSchool && 'SCHOOL_SEARCH_TITLE_TEXT';
    var findSchoolPageTitle = this.isFindSchool && 'SCHOOL_SEARCH_HELP_TITLE_TEXT';
    return fmpdPageTitle || landingPagTitle || findSchoolPageTitle;
  };

  // Method for handling the search when the user is coming from the "Confirm Existing Student Popup"
  this.searchFromConfirmExistingStudentPopup = function () {
    return this._getAccounts();
  };

  this._getAccounts = function () {
    this.isLoading = true;
    const searchedZipCode = this.schoolZipCode;
    const searchedState = this.schoolState;
    const searchedName = this.schoolName;
    this.getAccountApi()
      .getAccounts(searchedState?.name || null, searchedName, searchedZipCode, this.isFindMyPictureDay)
      .subscribe({
        next: (accounts) => {
          $scope.$evalAsync(() => {
            this.lastResults = accounts;
            this.lastSearch = {
              schoolZipCode: searchedZipCode,
              schoolState: searchedState,
              schoolName: searchedName,
              isFindMyPictureDay: this.isFindMyPictureDay
            };
            this.accounts = this.lastResults;
            this.sortResults();
            this.isLoading = false;
          });
        },
        error: (err) => {
          $scope.$evalAsync(() => {
            if (err.message === 'LMI_UNAVAILABLE_ERROR') {
              MessageStore.createGrowler(err.message, '', 'error');
            } else {
              ErrorLogService(err);
              this.lastResults = [];
              this.lastSearch = {};
              MessageStore.clear();
              MessageStore.createSystem('COMMON_TEXT_ERROR');
              AnalyticsService.addAdobeFormErrorEvent(
                AnalyticsService.ADOBE_FORM_IDS.GUEST_FIND_MY_PICTURE_DAY,
                AnalyticsService.ADOBE_ERROR_DESCRIPTIONS.SEARCH_ERROR
              );
            }
            this.isLoading = false;
          });
        }
      });
  };
  // Method for handling the general search case
  this.searchGeneral = function () {
    return this._getAccounts();
  };

  // Refactor the main method to check the condition and call the appropriate method
  this.searchSchools = function () {
    if (this.fromConfirmExistingStudentPopup) {
      this.searchFromConfirmExistingStudentPopup();
    } else {
      this.searchGeneral();
    }
  };

  this.filterResults = function () {
    this.accounts = R.filter(
      function (account) {
        return !!account.accountAlias && account.accountAlias.toLowerCase().indexOf(this.schoolName.toLowerCase()) >= 0;
      }.bind(this)
    )(this.lastResults || []);
    this.sortResults();
  };

  // sort by accounts with name that starts with searched name first, then by account name alphabetically
  this.sortResults = function () {
    //condition to check the no school found error
    this.isErrorShowable = this.accounts.length === 0;

    this.accounts = R.sort(
      function (aAccount, bAccount) {
        var aStarts = aAccount.accountAlias.toLowerCase().indexOf(this.schoolName.toLowerCase()) === 0;
        var bStarts = bAccount.accountAlias.toLowerCase().indexOf(this.schoolName.toLowerCase()) === 0;

        if (aStarts && bStarts) {
          return 0;
        }
        if (aStarts && !bStarts) {
          return -1;
        }
        if (!aStarts && bStarts) {
          return 1;
        }
      }.bind(this)
    )(R.sortBy(R.prop('accountAlias'))(this.accounts));
  };

  this.onPause = function () {
    if (this.schoolName.length >= 3) {
      // if school city/state are different, or if the results can't be filtered, make call to server for results
      if (
        this.lastSearch.schoolZipCode !== this.schoolZipCode ||
        this.lastSearch.schoolState !== this.schoolState ||
        !this.needsOnlyFiltering() ||
        this.fromConfirmExistingStudentPopup
      ) {
        this.searchSchools();
      } else if (this.needsOnlyFiltering()) {
        // timeout due to some funny business with the keypress timing
        $timeout(this.filterResults());
      }
    }
  };

  this.selectAccount = function (account) {
    this.selectedAccount = account;
    this.schoolName = account.accountAlias;
    this.selectedAccount.studentIdSelected = this.studentIdSelected;
    if (this.isFindMyPictureDay || this.isFindSchool || this.fromConfirmExistingStudentPopup) {
      this.searchAccount(this.selectedAccount.lifetouchId);
    }
  };

  this.resetSelected = function () {
    this.selectedAccount = null;
    this.filterResults();
  };

  this.schoolSearchEnabled = function () {
    if (!this.fromConfirmExistingStudentPopup) {
      return !!this.schoolZipCode && !!this.schoolState && $scope.vaildateZipCode();
    } else {
      return !!this.schoolZipCode && $scope.vaildateZipCode();
    }
  };

  this.continue = function () {
    $scope.onContinue();
    SubjectStore.selectAccount({
      lifetouchId: this.selectedAccount.lifetouchId,
      accountAlias: this.selectedAccount.accountAlias,
      city: $filter('CapitalizationFilter')(this.selectedAccount.city),
      zipcode: this.lastSearch.schoolZipCode,
      state: this.lastSearch.schoolState,
      masterEvents: this.selectedAccount.masterEvents,
      isFindMyPictureDay: false,
      studentIdSelected: this.selectedAccount.activeAccount === 'A'
    });
    if (this.fromConfirmExistingStudentPopup) {
      this.subject = SubjectStore.getSelectedSubject();
      if (this.subject) {
        SubjectStore.updateAccountInfo(this.schoolName, this.subject.masterSubjectId);
        this.subject.fromConfirmExistingStudentPopup = true;
        var event = this.findSelectedEvent(this.activeDayId);
        ConfirmSchoolService.loadJobFromEvent(event, this.fromConfirmExistingStudentPopup);
      }
    } else {
      BlockService.manuallyUnblockUI();
      RouterService.goToStudentInfo();
    }
  };

  this.findSelectedEvent = function (eventId) {
    return R.find(function (event) {
      return event.eventType.jobNumber === eventId;
    })(this.selectedAccount.masterEvents);
  };

  this.setupSelectedAccount = function (studentIdSelected) {
    SubjectStore.selectAccount({
      lifetouchId: this.selectedAccount.lifetouchId,
      accountAlias: this.selectedAccount.accountAlias,
      city: $filter('CapitalizationFilter')(this.selectedAccount.city),
      zipcode: this.lastSearch.schoolZipCode,
      state: this.lastSearch.schoolState,
      isFindMyPictureDay: this.isFindMyPictureDay,
      studentIdSelected: studentIdSelected,
      masterEvents: this.selectedAccount.masterEvents,
      pictureDateInfo: this.pictureDateInfo,
      retakeDateInfo: this.retakeDateInfo
    });
  };

  this.redirectToNext = function () {
    if (this.eventFound()) {
      AnalyticsService.addAdobeFormSuccessEvent(AnalyticsService.ADOBE_FORM_IDS.GUEST_FIND_MY_PICTURE_DAY);

      if (this.isInActiveAccount()) {
        this.setupSelectedAccount(false);
        this.showHideFindMyPictureDay();
      } else {
        this.setupSelectedAccount(true);
        if (this.isLoggedIn) {
          if (this.isFindSchool) {
            this.loadPreorderEvent();
            return;
          }
          this.continue();
          this.showHideFindMyPictureDay();
        } else {
          if (!this.isFindSchool) {
            RouterService.goToLogin();
          } else {
            this.loadPreorderEvent();
          }
        }
      }
    } else {
      this.resetForm();
      this.selectedAccount = null;
      this.lastResults = null;
      this.accounts = null;
      this.filterResults();
      this.isErrorShowable = false;
    }
  };

  this.loadPreorderEvent = function () {
    MessageStore.clear();

    const formData = { pictureDayId: this.activeDayId };

    if ($window.optimizeprepic) {
      this.validatingCode = true;
      return AddNewStudentFormSubmissionService.loadJobForAddStudentForm(formData, false).finally(
        () => (this.validatingCode = false)
      );
    }

    BlockService.blockUI();
    JobStore.loadJob(formData, false)
      .then(
        function (data) {
          // data === true -> means that we have that job loaded (JobStore.js file line 179)
          if ((data && data.data && data.data.success) || (typeof data === 'boolean' && data === true)) {
            RouterService.goToPrepayStudentInfo();
          }
        }.bind(this)
      )
      ['finally'](function () {
        BlockService.unblockUI();
      });
  };

  this.isInActiveAccount = function () {
    return this.selectedAccount.activeAccount === 'I';
  };

  this.eventFound = function () {
    return (
      (this.pictureDateInfo.length > 0 || this.retakeDateInfo.length > 0) &&
      this.selectedAccount &&
      this.selectedAccount.masterEvents &&
      !!this.selectedAccount.masterEvents.length
    );
  };

  this.showHideFindMyPictureDay = function () {
    $scope.showHideFindMyPictureDay();
  };

  this.processSchoolEventDate = function () {
    this.pictureDateInfo = [];
    this.retakeDateInfo = [];
    let x = 0;
    let y = 0;

    R.forEachIndexed(
      function (event, index) {
        if (this.selectedAccount.masterEvents[index].type === EventType.ORIGINAL) {
          this.pictureDateInfo.push({
            startDate: this.selectedAccount.masterEvents[index].eventType.eventDate,
            endDate: this.selectedAccount.masterEvents[index].eventType.lastPictureDay,
            jobNumber: this.selectedAccount.masterEvents[index].eventType.jobNumber
          });
          this.setDisplayDate(this.pictureDateInfo[x]);
          x++;
        } else if (this.selectedAccount.masterEvents[index].type === EventType.RETAKE) {
          this.retakeDateInfo.push({
            startDate: this.selectedAccount.masterEvents[index].eventType.eventDate,
            endDate: this.selectedAccount.masterEvents[index].eventType.lastPictureDay,
            jobNumber: this.selectedAccount.masterEvents[index].eventType.jobNumber
          });
          this.setDisplayDate(this.retakeDateInfo[y]);
          y++;
        }
      }.bind(this),
      this.selectedAccount.masterEvents
    );

    if (this.pictureDateInfo.length > 0) {
      this.pictureDateInfo
        .sort(function (a, b) {
          return new Date(a.endDate) - new Date(b.endDate);
        })
        .splice(2);
    }
    if (this.retakeDateInfo.length > 0) {
      this.retakeDateInfo
        .sort(function (a, b) {
          return new Date(a.endDate) - new Date(b.endDate);
        })
        .splice(2);
    }
    this.activeDayId = this.pictureDateInfo[0] && this.pictureDateInfo[0].jobNumber;
  };

  this.getButtonLabel = function () {
    if (this.eventFound()) {
      if (this.isFindSchool) {
        return this.isValidatingCode() ? 'VALIDATING_YOUR_CODE' : 'PICTURE_DAY_FORM_SUBMIT';
      }
      if (this.isInActiveAccount()) {
        return 'FIND_MY_PICTURE_DAY_SCHOOL_ORDER_WITH_SHOP_NOW';
      } else if (!this.fromConfirmExistingStudentPopup) {
        return 'SCHOOL_SEARCH_CONTINUE';
      } else if (this.fromConfirmExistingStudentPopup) {
        return 'MY_DASHBOARD_START_SHOPPING_BUTTON';
      }
    } else {
      return 'FIND_MY_PICTURE_DAY_SCHOOL_SEARCH_AGAIN';
    }
  };

  this.resetForm = function () {
    this.schoolName = null;
    this.schoolState = null;
    this.schoolZipCode = null;
  };

  this.setDisplayDate = function (dateInfo) {
    var startDate = new Date(dateInfo.startDate + 'T00:00:00');
    var endDate = new Date(dateInfo.endDate + 'T00:00:00');
    if (dateInfo.startDate === dateInfo.endDate) {
      dateInfo.displayDate =
        endDate.toLocaleString('en-US', { weekday: 'long' }) +
        ', ' +
        endDate.toLocaleDateString('en-US', { month: 'short' }) +
        ' ' +
        endDate.getDate() +
        ', ' +
        endDate.getUTCFullYear();
    } else {
      if (startDate.getUTCFullYear() === endDate.getUTCFullYear()) {
        dateInfo.displayDate =
          startDate.toLocaleString('en-US', { weekday: 'long' }) +
          ', ' +
          startDate.toLocaleString('en-US', { month: 'short' }) +
          ' ' +
          startDate.getDate() +
          ' - ' +
          endDate.toLocaleString('en-US', { weekday: 'long' }) +
          ', ' +
          endDate.toLocaleString('en-US', { month: 'short' }) +
          ' ' +
          endDate.getDate() +
          ', ' +
          endDate.getUTCFullYear();
      } else {
        dateInfo.displayDate =
          startDate.toLocaleString('en-US', { weekday: 'long' }) +
          ', ' +
          startDate.toLocaleString('en-US', { month: 'short' }) +
          ' ' +
          startDate.getDate() +
          ' ' +
          startDate.getUTCFullYear() +
          ' - ' +
          endDate.toLocaleString('en-US', { weekday: 'long' }) +
          ', ' +
          endDate.toLocaleString('en-US', { month: 'short' }) +
          ' ' +
          endDate.getDate() +
          ', ' +
          endDate.getUTCFullYear();
      }
    }
  };

  this.getDisplayInfo = function (dateInfo) {
    return dateInfo.displayDate + ' (' + dateInfo.jobNumber + ')';
  };

  this.setActiveDayId = function (id) {
    this.activeDayId = id;
  };

  this.getEventType = function (eventType) {
    if (eventType === EventType.ORIGINAL) return 'FIND_MY_PICTURE_DAY_SCHOOL_PICTURE_DAY';
    else if (eventType === EventType.RETAKE) return 'FIND_MY_PICTURE_DAY_SCHOOL_RETAKE_DAY';
  };

  this.goBack = function () {
    RouterService.goBack();
  };

  this.goToIDontHaveCode = function () {
    $scope.onCancel();
    RouterService.goToIDontHaveCode();
  };

  $scope.validateMaxSchoolLength = function () {
    var valid = $scope.schoolSearch.schoolName && $scope.schoolSearch.schoolName.length >= MAX_VALID_HOST_NAME_LENGTH;
    $scope.schoolsSearchForm.schoolNames.$setValidity('maxlength', !valid);
    return valid;
  };

  $scope.validateMinSchoolLength = function () {
    return (
      $scope.schoolSearch.schoolName &&
      $scope.schoolSearch.schoolName.length < 3 &&
      $scope.schoolSearch.schoolName.length > 0
    );
  };

  $scope.vaildateZipCode = function () {
    const code = $scope.schoolSearch.schoolZipCode || '';
    const codeLength = $scope.schoolSearch.isCanadian ? CA_ZIP_CODE_LENGTH : US_ZIP_CODE_LENGTH;
    return code.replace(/\s+/g, '').length === codeLength;
  };

  $scope.onZipCodeFocus = function () {
    $scope.schoolSearch.zipCodeError = false;
  };

  $scope.onZipCodeBlur = function () {
    if (!$scope.schoolSearch.schoolZipCode) {
      return;
    }
    $scope.schoolSearch.zipCodeError = !$scope.vaildateZipCode();
  };

  $scope.onZipCodeChange = function () {
    let zipCode = $scope.schoolSearch.schoolZipCode || '';

    if (!$scope.schoolSearch.isCanadian) {
      $scope.schoolSearch.schoolZipCode = zipCode.replace(/[^0-9]/g, '').slice(0, US_ZIP_CODE_LENGTH);
      return;
    }

    const regex = new RegExp(`^(.{${SPACE_INDEX}})(.*)$`);

    zipCode = zipCode.toUpperCase().replace(/[^A-Z0-9 ]/g, '');

    let filtered = zipCode.replace(/\s+/g, '');

    // If user type a space at index 3, accept it.
    if (zipCode[SPACE_INDEX] === ' ' && filtered.length >= SPACE_INDEX) {
      zipCode = filtered.replace(regex, '$1 $2');
    } else {
      zipCode = filtered.length > SPACE_INDEX ? filtered.replace(regex, '$1 $2') : filtered;
    }

    $scope.schoolSearch.schoolZipCode = zipCode.slice(0, CA_ZIP_TOTAL_LENGTH);
  };

  this.isValidatingCode = () => Boolean($window.optimizeprepic) && this.validatingCode;
}

App.controller('LtSchoolSearchCtrl', [
  '$scope',
  '$timeout',
  '$filter',
  '$location',
  'RouterService',
  'StatesService',
  'TranslateProviderService',
  'ErrorLogService',
  'SubjectStore',
  'MessageStore',
  'UserProfileStore',
  'BlockService',
  'JobStore',
  'AnalyticsService',
  'ConfirmSchoolService',
  'ShoppingCartStore',
  '$injector',
  '$window',
  'AddNewStudentFormSubmissionService',
  LtSchoolSearchCtrl
]);
